var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1716984665620,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 22261,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.123217 241.901809c0-107.626482 87.252964-194.879445 194.879445-194.879445s194.870572 87.252964 194.870572 194.879445-87.24409 194.870572-194.870572 194.870572c-107.626482 0-194.879445-87.24409-194.879445-194.870572zM117.962315 705.073692c0-138.390849 176.413726-250.587175 394.03591-250.587176s394.03591 112.196326 394.03591 250.587176c0 138.399723-176.413726 250.593386-394.03591 250.593386s-394.03591-112.193664-394.03591-250.593386z",
    fill: "#89B7FF",
    "p-id": 22262
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRound);
export default __webpack_public_path__ + "static/media/user-round.2063250601db5618856cf5580b3b74b0.svg";
export { ForwardRef as ReactComponent };